/*
 * Copyright (c) 2019  Apricad LLC. All Rights Reserved.
 */

import { createSelector } from "reselect";

// --- for All Courses ---
// ----------------------------------------------------------------------

// Function to retrieve piece of state
const dataCourses = (state: any) => state.state_course.courses;

// Function that has our select logic. Input: piece of state, Output: calcauted result
// This selector is for caching all courses, so simply return all courses is the logic.
const getCourses = (courses: any) => {
  return courses;
};

// Selector consumed by components consuming
export const selectorCourses = createSelector(
  [dataCourses], // pick off piece of state
  getCourses, // function with logic
);

// Selector consumed by action creator to check if courses are loaded
export const allCoursesLoaded = createSelector(
  [dataCourses], // pick off piece of state
  (courses) => courses.length != 0, // function with logic, return true/false only here
);

// --- for Current (single) Course ---
// ----------------------------------------------------------------------

// Function to retrieve piece of state
const dataCourseId = (state: any, props: any) => props.id;
const dataCurrentCourse = (state: any) => state.state_course.currentCourse;

export const selectorCurrentCourse = createSelector(
  [dataCurrentCourse],
  (currentCourse) => currentCourse,
);

export const currentCourseLoaded = createSelector(
  [dataCourseId, dataCurrentCourse],
  (courseRequested_id, currentCourse) =>
    currentCourse && currentCourse._id === courseRequested_id,
);

// --- for Current (single) Lecture ---
// ----------------------------------------------------------------------

// Function to retrieve piece of state
const dataLectureId = (state: any, props: any) => props.lid;
const dataCurrentLecture = (state: any) => state.state_course.currentLecture;

// Selector consumed by components consuming
export const selectorCurrentLecture = createSelector(
  [dataCurrentLecture],
  (currentLecture) => currentLecture,
);

// Selector consumed by action creator to check if the lecture is loaded
export const currentLectureLoaded = createSelector(
  [dataLectureId, dataCurrentLecture],
  (lectureRequested_id, currentLecture) =>
    currentLecture && currentLecture._id === lectureRequested_id,
);
